import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
);

if (environment.envName === "prod") {
    const clarityWindow = window as typeof window & {
        clarity?: (...args: unknown[]) => void;
    };
    clarityWindow.clarity =
        clarityWindow.clarity ??
        ((...args: unknown[]) => {
            const queuedClarity =
                clarityWindow.clarity as typeof clarityWindow.clarity & {
                    q?: unknown[][];
                };
            queuedClarity.q = queuedClarity.q ?? [];
            queuedClarity.q.push(args);
        });

    const clarityScript = document.createElement("script");
    clarityScript.async = true;
    clarityScript.src = "https://www.clarity.ms/tag/stm2cnmc5q";
    document.head.appendChild(clarityScript);
    console.info("[Clarity] enabled for ", environment.envName);
}

if (environment.gaMeasurementId) {
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaMeasurementId}`;
    document.head.appendChild(script1);

    const analyticsWindow = window as typeof window & {
        dataLayer?: unknown[];
        gtag?: (...args: unknown[]) => void;
    };
    analyticsWindow.dataLayer = analyticsWindow.dataLayer ?? [];
    analyticsWindow.gtag = (...args: unknown[]) =>
        analyticsWindow.dataLayer?.push(args);
    analyticsWindow.gtag("js", new Date());
    analyticsWindow.gtag("config", environment.gaMeasurementId);
}
